<template>
  <v-card class="mx-auto" flat>
    <v-container>
      <div class="pa-5">
        <v-row>
          <v-col cols="12" lg="6" class="pa-7">
            <p class="text-justify black--text">
              Jenjang satuan pendidikan penugasan sebagai FS Saat Ini
            </p>
            <div v-for="(jenjang, id) in jenjangs" :key="id">
              <v-row align="center">
                <v-col cols="12" lg="3">
                  <v-checkbox
                    v-model="aktifsValues"
                    :value="jenjang.k_jenjang"
                    hide-details
                    class="shrink mt-0"
                    @change="onChangeAktif(jenjang.k_jenjang)"
                  >
                    <template v-slot:label>
                      <div style="width: 100px">{{ jenjang.label }}</div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col v-show="+aktifs[jenjang.k_jenjang]['is_pilih'] === 1" cols="12" lg="9">
                  <v-text-field
                    v-model="aktifs[jenjang.k_jenjang]['jumlah']"
                    label="Tuliskan jumlah pendampingan"
                    type="number"
                    min="0"
                    dense
                    outlined
                    hide-details
                  />
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="pa-7">
            <p class="text-justify black--text">
              Sebutkan jenjang satuan pendidikan yang pernah Bapak / Ibu dampingi sebelumnya
              <br />
              <em>
                <small class="grey--text text--darken-1">
                  (Tidak perlu dipilih jika tidak memiliki riwayat satuan pendidikan yang pernah di dampingi)
                </small>
              </em>
            </p>
            <div v-for="(jenjang, id) in jenjangs" :key="id">
              <v-row align="center">
                <v-col cols="12" lg="3">
                  <v-checkbox
                    v-model="lamasValues"
                    :value="jenjang.k_jenjang"
                    hide-details
                    class="shrink mt-0"
                    @change="onChangeLama(jenjang.k_jenjang)"
                  >
                    <template v-slot:label>
                      <div style="width: 100px">{{ jenjang.label }}</div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" lg="6" class="pa-7">
            <p class="text-justify black--text">
              Sebutkan jenjang satuan pendidikan yang menjadi prioritas untuk Bapak/Ibu dampingi jika terpilih sebagai
              Fasilitator angkatan mendatang?
            </p>
            <div v-for="(prioritas, id) in rencanas" :key="id">
              <v-row align="center">
                <v-col cols="12" lg="3"> Prioritas {{ id + 1 }} </v-col>
                <v-col cols="12" lg="9">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <v-select
                        v-model="rencanas[id]"
                        :items="options"
                        placeholder="Pilih Jenjang"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col cols="2" class="text-right my-auto">
                      <v-icon
                        v-if="rencanas.length > 1"
                        large
                        color="red"
                        @click="onDelPrioritas(id)"
                        style="cursor: pointer"
                      >
                        mdi-close-circle
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="my-5" />
            </div>
            <v-btn
              @click="onAddPrioritas"
              :disabled="rencanas.length === jenjangs.length"
              depressed
              color="primary"
              class="text-capitalize mr-2"
            >
              <v-icon small left>mdi-plus</v-icon> Tambah Data
            </v-btn>
            <v-btn
              @click="onAddAllPrioritas"
              :disabled="rencanas.length === jenjangs.length"
              depressed
              color="success"
              class="text-capitalize"
            >
              <v-icon small left>mdi-plus</v-icon> Semua Jenjang
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'FormPenugasan',
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    const jenjangs = [
      { label: 'TK-PAUD', k_jenjang: 1 },
      { label: 'SD', k_jenjang: 2 },
      { label: 'SMP', k_jenjang: 3 },
      { label: 'SMA', k_jenjang: 4 },
      { label: 'SLB', k_jenjang: 6 },
    ];

    let aktifs = {};
    let aktifsValues = [];
    for (const jenjang of jenjangs) {
      aktifs[jenjang.k_jenjang] = {
        is_pilih: null,
        jumlah: null,
      };
    }

    let lamas = {};
    let lamasValues = [];
    for (const jenjang of jenjangs) {
      lamas[jenjang.k_jenjang] = {
        is_pilih: null,
      };
    }

    let rencanas = [null];

    return { jenjangs, aktifs, aktifsValues, lamas, lamasValues, rencanas };
  },
  computed: {
    options() {
      let result = [];

      for (const jenjang of this.jenjangs) {
        result.push({
          text: jenjang.label,
          value: jenjang.k_jenjang,
          disabled: this.rencanas.includes(jenjang.k_jenjang),
        });
      }

      return result;
    },
  },
  methods: {
    reset() {
      const tugases = (this.$getDeepObj(this.initValue, 'psp_biodata_tugases') || []).sort(
        (a, b) => a.prioritas - b.prioritas
      );
      let aktifs = {};
      let lamas = {};
      let rencanas = [];

      for (const tugas of tugases) {
        if (tugas.status_gelombang === 'aktif') {
          aktifs[Number(tugas.k_jenjang)] = { is_pilih: 1, jumlah: tugas.jml_pendampingan || null };
        } else if (tugas.status_gelombang === 'selesai') {
          lamas[Number(tugas.k_jenjang)] = { is_pilih: 1 };
        } else if (tugas.status_gelombang === 'rencana') {
          rencanas.push(tugas.k_jenjang);
        }
      }

      for (const id in this.aktifs) {
        this.$set(this.aktifs[id], 'is_pilih', this.$getDeepObj(aktifs, `${id}.is_pilih`) || null);
        this.$set(this.aktifs[id], 'jumlah', this.$getDeepObj(aktifs, `${id}.jumlah`) || null);
      }

      for (const id in this.lamas) {
        this.$set(this.lamas[id], 'is_pilih', this.$getDeepObj(lamas, `${id}.is_pilih`) || null);
      }

      this.aktifsValues = Object.keys(aktifs).length
        ? Object.keys(aktifs).map((kJenjang) => {
            return Number(kJenjang);
          })
        : [];
      this.lamasValues = Object.keys(lamas).length
        ? Object.keys(lamas).map((kJenjang) => {
            return Number(kJenjang);
          })
        : [];
      this.rencanas = rencanas.length ? rencanas : [null];
    },

    getValue() {
      return { aktifs: this.aktifs, lamas: this.lamas, rencanas: this.rencanas };
    },

    onChangeAktif(kJenjang) {
      this.aktifs[kJenjang]['jumlah'] = null;

      if (this.aktifs[kJenjang]['is_pilih'] === null) {
        this.aktifs[kJenjang]['is_pilih'] = 1;
      } else {
        this.aktifs[kJenjang]['is_pilih'] = null;
      }
    },

    onChangeLama(kJenjang) {
      if (this.lamas[kJenjang]['is_pilih'] === null) {
        this.lamas[kJenjang]['is_pilih'] = 1;
      } else {
        this.lamas[kJenjang]['is_pilih'] = null;
      }
    },

    onAddPrioritas() {
      this.rencanas.push(null);
    },

    onAddAllPrioritas() {
      this.rencanas = this.jenjangs.map((jenjang) => {
        return jenjang.k_jenjang;
      });
    },

    onDelPrioritas(id) {
      this.rencanas.splice(id, 1);
    },
  },
};
</script>

<style scoped></style>
